import { FocusTrap } from './modules/focustrap.js';
import { HashManager } from './modules/hashmanager.js';

import './components/helpers.js';
import './components/notifications.js';
import './components/request.js';
import './components/filter.js';
import './data.js';

import './components/site/controls.js';
import './components/site/header.js';
import './components/site/navigation.js';
import './components/site/misc.js';
import './components/site/tracking.js';

import './components/ui/tabs.js';
import './components/ui/accordion.js';
import './components/ui/modal.js';
import './components/ui/form.js';
import './components/ui/slider.js';
import './components/ui/tooltip.js';

import './pages/downloads.js';
import './pages/legal.js';
import './pages/products.js';

window.app = window.app || {};

app.init = () => {
    document.documentElement.classList.remove('no-js');
    // data
    app.data.init();

    // site
    app.site.header();
    app.site.navigation();
    app.site.misc();
    app.site.tracking.init();

    // ui
    app.ui.tabs();
    app.ui.accordion();
    app.ui.modal.init();
    app.ui.form.init();
    app.ui.slider();
    app.ui.tooltip();

    // pages
    app.pages.downloads.init();
    app.pages.legal.init();
    app.pages.products.init();
};

window.addEventListener('DOMContentLoaded', app.init);